export default __webpack_public_path__ + "static/referral-partner-57f0134dec0dee2fa7a3ba78a48c9e32.png";